import { customElement, useView, PLATFORM, bindingMode, computedFrom } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { NumeralConverter } from '@dynamik/common';
import { IValidatedElement, IError } from '@aurelia-mdc-web/base';

@customElement('number-field')
@useView(PLATFORM.moduleName('./number-field.html'))
export class NumberField {
  constructor(public root: Element, private numeralConverter: NumeralConverter) {
    defineInstrumentLookupElementApis(this.root as HTMLElement);
  }

  valueString: string;
  input: HTMLInputElement & { isFocused: boolean };

  @bindable
  label: string;
  @bindable
  icon: string;

  @computedFrom('format')
  get options() {
    return {
      greedy: false,
      alias: 'currency',
      radixPoint: ',',
      groupSeparator: ' ',
      digits: (this.format === 'twoDec' ? 2 : (this.format === 'fourDec' ? 4 : 0)),
      autoGroup: true,
      rightAlign: false,
      prefix: ''
    };
  }

  @bindable({ defaultBindingMode: bindingMode.twoWay })
  value: number;
  valueChanged() {
    this.valueString = isNaN(this.value) ? '' : this.numeralConverter.format(this.value, this.format);
  }

  @bindable.booleanAttr
  readonly: boolean;

  @bindable.booleanAttr
  disabled: boolean;

  @bindable
  format: 'twoDec' | 'fourDec' | 'zeroDec' = 'twoDec';

  

  updateValue() {
    const value = this.numeralConverter.parse(this.valueString);
    this.value = isNaN(value) ? undefined : value;
  }

  addError(error: IError) {
    if (this.input && Object.getOwnPropertyDescriptor(this.input, 'addError')) {
      (this.input as HTMLElement as IValidatedElement).addError(error);
    }
  }

  removeError(error: IError) {
    if (this.input && Object.getOwnPropertyDescriptor(this.input, 'addError')) {
      (this.input as HTMLElement as IValidatedElement).removeError(error);
    }
  }

  renderErrors() {
    if (this.input && Object.getOwnPropertyDescriptor(this.input, 'renderErrors')) {
      (this.input as HTMLElement as IValidatedElement).renderErrors();
    }
  }

  iconButtonClicked() {
    this.root.dispatchEvent(new CustomEvent('icon-button-clicked', { bubbles: true }));
  }
}

export interface INumberFieldElement extends IValidatedElement {
  au: {
    controller: {
      viewModel: NumberField;
    };
  };
}

function defineInstrumentLookupElementApis(element: HTMLElement) {
  Object.defineProperties(element, {
    addError: {
      value(this: INumberFieldElement, error: IError) {
        this.au.controller.viewModel.addError(error);
      },
      configurable: true
    },
    removeError: {
      value(this: INumberFieldElement, error: IError) {
        this.au.controller.viewModel.removeError(error);
      },
      configurable: true
    },
    renderErrors: {
      value(this: INumberFieldElement): void {
        this.au.controller.viewModel.renderErrors();
      },
      configurable: true
    },
  });
}

